import { FormField, FormService } from '../services/formService';
import { Validations, Validators } from '../services/validations';
import { BaseModel } from './baseModel';

export class ConcessionModel extends BaseModel{
  concession_name: FormField;
  concession_type: FormField;
  value: FormField;
  attribute: FormField;
  merit_value: FormField;
  selected_category: Array<any> = []
  email_id: FormField;
  concession_form: FormField;
  approval_required: FormField;
  constructor() {
    super();
    this.concession_name = new FormField("", true, [Validations.EMPTY]);
    this.concession_type = new FormField("", true, [Validations.EMPTY]);
    this.value = new FormField("", true, [Validations.EMPTY, Validations.DECIMAL]);
    this.attribute = new FormField("", true, [Validations.EMPTY]);
    this.merit_value = new FormField("", false, [Validations.EMPTY, Validations.DECIMAL]);
    this.email_id = new FormField("", false, [Validations.EMPTY, Validations.EMAIL]);
    this.selected_category = []
    this.concession_form = new FormField("", false);
    this.approval_required = new FormField(false,false)
  }
}

export class ConcessionModifyModel extends BaseModel{
  concession_name: FormField;
  concession_type: FormField;
  value: FormField;
  attribute: FormField;
  merit_value: FormField;
  selected_category: FormField
  email_id: FormField;
  approval_required: FormField;
  constructor() {
    super();
    this.concession_name = new FormField("", true, [Validations.EMPTY]);
    this.concession_type = new FormField("", true, [Validations.EMPTY]);
    this.value = new FormField("", true, [Validations.EMPTY, Validations.DECIMAL]);
    this.attribute = new FormField("", true, [Validations.EMPTY]);
    this.merit_value = new FormField("", false, [Validations.EMPTY, Validations.DECIMAL]);
    this.email_id = new FormField("", false, [Validations.EMPTY, Validations.EMAIL]);
    this.selected_category = new FormField("", false, [Validations.EMPTY]);
    this.approval_required = new FormField(false,false)

  }
}
